const GEO_IP_ATTRIBUTES: readonly string[] = [
  'cio_iso_country',
  'cio_country',
  'cio_city',
  'cio_timezone',
  'cio_latitude',
  'cio_longitude',
  'cio_iso_continent',
  'cio_continent',
  'cio_iso_region',
  'cio_region',
  'cio_postal_code',
];

/** Whether Customer.io derives `key` from the profile's IP address. */
export function isGeoIpAttribute(key: string): boolean {
  return GEO_IP_ATTRIBUTES.includes(key);
}

/**
 * Whether an attribute value is a JSON object or array. Scalars that also
 * parse (`"1"`, `"null"`) are ordinary values.
 */
export function isJsonAttribute(value: string): boolean {
  try {
    const parsed: unknown = JSON.parse(value);
    return typeof parsed === 'object' && parsed !== null;
  } catch {
    return false;
  }
}
